import React from 'react';
import {Button} from 'antd';

import './index.styl';

class Buttonc extends Button{
    render() {
        return (
            <Button {...this.props} />
        )
    }
}

export default Buttonc;
